import { TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

type WizardTextFieldProps = {
  label: string;
  name: string;
  helperText?: string;
};

export const WizardTextField = ({
  label,
  name,
  helperText = '',
}: WizardTextFieldProps) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const errorMessage = (errors[name]?.message as string) || helperText;
  const isError = !!errors[name];

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        return (
          <TextField
            {...field}
            label={label}
            helperText={errorMessage}
            error={isError}
          />
        );
      }}
    />
  );
};

